<template>
  <v-dialog
    :model-value="isOpen"
    :width="width"
    content-class="rtls-dialog"
    @update:model-value="$emit('close')"
  >
    <BaseDialogCard is-popup :title="title" content-class="no-max-height" @close="$emit('close')">
      <slot />
      <template #footer>
        <v-row>
          <v-col :cols="12" align-self="center" class="d-flex justify-center">
            <v-btn primary @click="$emit('close')">
              {{ $t('actions.ok') }}
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </BaseDialogCard>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    width: {
      type: String,
      required: false,
      default: '20%',
    },
  },
};
</script>

<style scoped></style>
